import React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import styles from "./customSnackbar.module.scss";
import i18next from "i18next";
import PropTypes from "prop-types";

const CustomSnackbar = (props) => {
  const {
    open = false,
    setOpen,
    message = "",
    position = {
      vertical: "bottom",
      horizontal: "right",
    },
    duration = 6000,
    successMessage = true,
  } = props;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <Box>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
  const customMessage = (
    <Box className={styles.messageWrapper}>
      <Box>
        <span className={styles.tickIcon}></span>
      </Box>
      <Box className={styles.message}>{i18next.t(message)}</Box>
    </Box>
  );

  return (
    <Box
      className={successMessage ? styles.snackBarWrapper : styles.snackBarError}
      data-testid="CustomSnackbar"
    >
      <Snackbar
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
        message={customMessage}
        action={action}
        anchorOrigin={position}
        key={position.vertical + position.horizontal}
      />
    </Box>
  );
};

export default CustomSnackbar;

CustomSnackbar.propTypes = {
  open: PropTypes.any,
  setOpen: PropTypes.any,
  message: PropTypes.any,
  position: PropTypes.any,
  duration: PropTypes.any,
  successMessage: PropTypes.any,
};
